import React from 'react'

import NavLinks from '../NavLinks'

const DesktopNav = () => <NavLinks mobile={false} />;

export default DesktopNav
